/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const yesNoOptionEnum = {
    No: 'No',
    Yes: 'Yes',
} as const;

export type YesNoOptionEnumKey = (typeof yesNoOptionEnum)[keyof typeof yesNoOptionEnum];

export type YesNoOption = YesNoOptionEnumKey;
